import Api from "@/api/api";
import ApiMock from '../api/api_mock';

const Plugin = {};

Plugin.install = function (Vue, options) {
  const api = options.mock ? new ApiMock() : new Api(options.baseUrl);

  api.setAuth((headers) => {
    const token = Vue.prototype.$auth.getToken();
    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }
    return headers;
  });

  api.onApiError = (e) => {
    console.error('API error:', e);
    if (e.status === 401) {
      options.router.push({ name: 'login' })
    }
  };

  Vue.prototype.$api = api;
}

export default Plugin;
